import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { NavigationLink } from '@stylehaven/components';
import { ApiFragment } from '../../entities/api-fragment.entity';
import { RecordNavigationService } from '../../../services/navigation/record-navigation.service';
import { defaultNavigationOptions } from '../../../../entities';
import { Task } from '../../../task/entities';
import { isPlainClick } from '../../helpers/plain-click.helper';

@Component({
    standalone: false,
    selector: 'digihaven-generic-title',
    templateUrl: './generic-title.component.html',
    styleUrls: ['./generic-title.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenericTitleComponent {
    @Input() title!: string;
    @Input() titleLabel!: string;
    @Input() subtitle?: string;
    @Input() subtitleLabel?: string;
    @Input() tooltip?: string;

    @Input() data!: ApiFragment | Task;
    @Input() navigationLink: NavigationLink | null;
    @Input() overviewId?: string;

    @Output() recordSelected: EventEmitter<ApiFragment | Task> = new EventEmitter<ApiFragment | Task>();

    constructor(private navigationService: RecordNavigationService) {}

    selectRecord(event: MouseEvent): void {
        if (!isPlainClick(event)) {
            return;
        }

        this.recordSelected.emit(this.data);
    }

    getNavigationLink(): NavigationLink {
        if (this.navigationLink !== undefined && this.navigationLink !== null) {
            return this.navigationLink;
        }
        return this.navigationService.getNavigationLink({
            record: this.data,
            navigationOptions: {
                ...defaultNavigationOptions,
                queryParams: {
                    ['overview']: this.overviewId
                }
            }
        });
    }

    getToolTip(): string {
        let tooltip = '';
        if (this.titleLabel) {
            tooltip += `${this.titleLabel}: `;
        }
        tooltip += this.title;
        if (this.subtitleLabel) {
            tooltip += `\n${this.subtitleLabel}: `;
        } else if (this.subtitle) {
            tooltip += `\n`;
        }
        if (this.subtitle) {
            tooltip += this.subtitle;
        }
        return tooltip;
    }
}
